export default __webpack_public_path__ + "static/media/img_scsc_13.5e5c40ec.png";